export const MAX_PIE_SEGMENTS = 20;
